<template>
  <div :class="$b({ inProductPage: productPageMode })">
    <div
      :class="$b('inner')"
    >
      <LiteProductCard
        :product="formattedProducts"
      />
    </div>
  </div>
</template>

<script>
import { filterValidLensTechDisplay } from '~/assets/js/helpers/search/search'

export default defineNuxtComponent({
  name: 'CrossSellItem',

  props: {
    sku: { type: String, required: true },
    hideTitle: { type: Boolean, default: false },
    hidePrice: { type: Boolean, default: false },
    hideReviews: { type: Boolean, default: false },
    hideButtons: { type: Boolean, default: false },
    productPageMode: { type: Boolean, default: false },
  },

  async setup(props) {
    const { $product, $i18n } = useNuxtApp()
    const formattedProducts = ref([])
    const heroDesigns = ref([])

    const customisedProduct = await $product.getCustomisedProduct(props.sku)

    function reviewSummary(item) {
      const reviewStore = useReviewsStore()

      if (item.useGenericReviews) {
        return reviewStore.aggregated
      }

      return item.product?.reviewSummary?.[0]
    }

    heroDesigns.value = (
      customisedProduct.product?.heroDesigns?.slice(0, 7) || []
    )
      .filter(
        (design) => !design.isLimitedEdition
          && design.frameOption && design.lensOption
      )
      .map((design) => ({
        sku: design.sku,
        baseSKU: customisedProduct.baseSKU,
        name: customisedProduct.product.name,
        nameSuffix: customisedProduct.frameTypeDetails?.title,
        productInfoTitle: customisedProduct.product.productInfoTitle,
        inStock: design.isInStock,
        onPreorder: design.isInStockOrOnPreorder,
        showOutOfStock: true,
        url: customisedProduct.url,
        legacySKU: design.legacySKU,
        price: design.price,
        lensTech: {
          displayValue: design.lensOption?.optionTech?.displayTitle,
          filterValue: design.lensOption?.lensTech,
        },
        lensColour: design.lensOption?.nameWithoutLensTech,
        frameColour: design.frameOption?.name,
        isLimitedEdition: design.isLimitedEdition,
        showReviews: customisedProduct.product.showReviews,
        useGenericReviews: customisedProduct.product.useGenericReviews,
        reviewSummary: reviewSummary(customisedProduct),
        swatchStyles: design.swatches,
        tagText: customisedProduct.product.tagTextWithOverride,
        tagTheme: customisedProduct.product.tagTheme,
      }))

    function buildItemPayload(item, index) {
      return {
        sku: item.sku,
        name: item.name,
        nameSuffix: item.nameSuffix,
        productInfoTitle: item.productInfoTitle,
        inStock: item.inStock,
        onPreorder: item.onPreorder,
        showOutOfStock: true,
        url: item.url,
        legacySKU: item.legacySKU,
        prices: { [$i18n.localeProperties.value.currency]: item.price },
        logo: item.logo,
        swatchIcon: { url: item.swatchIcon },
        lensTech: filterValidLensTechDisplay(item.lensTech),
        lensColour: item.lensColour,
        frameColour: item.frameColour,
        isLimitedEdition: item.isLimitedEdition || false,
        reviews: item.reviewSummary,
        swatchStyles: item.swatchStyles,
        tag: { text: item.tagText, theme: item.tagTheme },
        index,
      }
    }

    function transformItem(items) {
      const mainVariant = buildItemPayload(items[0], 0)

      mainVariant.variants = items.map((item, index) => {
        return buildItemPayload(item, index + 1)
      })

      return mainVariant
    }

    formattedProducts.value = transformItem(heroDesigns.value)
    
    return {
      formattedProducts
    }
  },
})
</script>

